export const COMPANY_LINES = [
  "TrustMaster Ltd · 6-7 St Mary At Hill, London, England, EC3R 8EE",
  "TrustMaster Srl · Via Guglielmo Oberdan, 23 · 45100 Rovigo (Italy) · P.IVA IT01683810293 · Cap. Sociale 10.000,00 I.V.",
  "Soggetta a direzione e coordinamento della società SURE MASTER CONSULTING LTD · 6-7 St Mary At Hill, London, England, EC3R 8EE · C.N. 06234182",
];
